import React, {Component, useState } from 'react';
import logo from './img/sn-logo.png';
import logo1 from './img/nadah.png';
import blog from './img/blog.png';
import ndah from './img/ndah_cer.jpeg';
import './App.css';

const d = new Date();
let year = d.getFullYear();
function App() {
  // const [sidemenu, setSidemenu] = useState(false);
  const [navbar, setNavbar] = useState(false);
  const [curlyOpen, setCurlyOpen] = useState("{");
  const [curlyClose, setCurlyClose] = useState("}");
  const [yearFetch, setYearFetch] = useState(year);

  // const sidemenuopen = () => {
  //   setSidemenu(true) 
  // };

  // const sidemenuclose = () => {
  //   setSidemenu(false) 
  // };

  const navbarbackground = () =>{
    if(window.scrollY >= 130){
      setNavbar(true);
    }else{  
      setNavbar(false);
    }
  }

  window.addEventListener('scroll', navbarbackground);

  return (
    <div className="telth_landingpage">

    {/* Navbar section start */}
    
    <section id="navbar-section">
      <div className="top-nav">
        <div className="row">
          <div className="col-8">
            <div className="nav-mail-num">
            <span className="mx-2"><i className="fa fa-phone" aria-hidden="true"></i> &nbsp; 04692610234</span>
              <span className="mx-2"><i className="fa fa-envelope" aria-hidden="true"></i> &nbsp;<a href="mailto:info@snhospital.in" style={{color:'white'}}>info@snhospital.in</a></span>
              <span className="mx-2"><i className="fa fa-map-marker" aria-hidden="true"></i> &nbsp; Kadapra , Kerala, india</span>
            </div>
          </div>
          <div className="col-4"  style={{display:'flex', justifyContent:'flex-end', color:'#2e2e4c'}}>
            <div className="social-media-icon-top">
              <a href="#"><i className="fa fa-facebook" aria-hidden="true"></i></a>
              <a href="#"><i className="fa fa-twitter" aria-hidden="true"></i></a> 
              <a href="#"><i className="fa fa-linkedin " aria-hidden="true"></i></a>
              </div>
          </div>
        </div>
      </div>
     <div className={navbar ? "telth_landingpage_navbar navbar-bg fixed-top" : "telth_landingpage_navbar"}>
     <nav className="navbar navbar-toggleable-md navbar-expand-lg sticky-top" id="mainNav">
    <div className="container-fluid navbar-container" style={{fontFamily: 'poppins'}}>
      <a className="navbar-brand js-scroll-trigger" href="#" style={{fontFamily: 'poppins'}}>
      <img src='./img/img/sn-logo.png' width='60px'/>
      </a>
      <button className="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
        <i class="fa fa-bars"></i>
      </button>
      <div className="collapse navbar-collapse" id="navbarResponsive">
        <ul className="navbar-nav ml-auto" style={{alignItems: "center"}}>
            <li className="nav-item">
                <a className="nav-link" href="#">home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="#our-services-section">About</a>
              </li>

        </ul>
      
      </div>
    </div>
  </nav>
       
      </div>
    </section>
    
      {/* Navbar section end */}
     
      {/* Header section start */}

      <section id="header-section">
       <header className="telth_landingpage_header">
       <div className="header-details">
         <div className="row m-0 header-contents">
           <div className="col-xs-12 col-sm-12 col-md-12 col-lg-9 col-xl-8" style={{display:'flex', justifyItems:'center', alignItems:'center'}}>
           <div className="header-content-btn">
           <div className="content">
             
 <h4 className="py-2 ">Welcome To <br/>S N Hospital</h4> 

           </div>

         </div>
           </div>
             
         </div>
        
        <div className="overlay"></div>
        </div>
      </header>
      
      </section>

       <section id="technology-section">
        <div className="technology-details">
          <div className="technology-title container">
            
              <div className="technology-title-sub">
             <center> <h5 style={{fontSize: '35px'}}><b>About Us</b><span style={{color: '#F88927', fontSize: '40px'}}>.</span></h5></center>
              </div>
              <div className="technology-title-tools">
              <div className="technology-tools">
                <div className="row">
                  <div className="col-xs-12 col-sm-12 col-md-3 col-lg-6 col-xl-6 tools-bg">
                    <div className="tools-title">
                      <img src='./img/img/11232145_863557720393709_4706361890767967150_o.jpg' width="500px" style={{borderRadius: '2%'}}/>
                    </div>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-9 col-lg-6 col-xl-6">
                    <div className="tools-logo1">
<h6 style={{color: 'grey', lineHeight: '30px'}} >S.N.Hospital is a NABH certified multi specialty hospital situated in Kadapra a place near Thiruvalla Kerala, The hospital is full fledged and well equipped with modern amenities.</h6>
                   <h6 style={{color: '#7F837F', lineHeight: '30px'}}>S.N.Hospital is founded by Dr.S.N.Pillai in the year of 1944. Dr S.N.Pillai hailing from Nedumpallil family started his career as a school teacher. He got inspired from his uncle Nedumpallil Padmanabha pillai who was a renowned ayurvedic paediatrician. Leaving his job as a school teacher he took his L.M.P (Licensed Medical Practitioner a degree given by British Govt.</h6>
                    </div>
                  </div>
                </div>
            </div>


          </div>

          <div class="row">
    <div class="col-md-4">
      <div class="thumbnail" style={{border: '10px solid #CBB79A'}}>

        <img src='./img/img/107896606_3175015815914543_2137527558136187998_n-copy.jpg' style={{width: '100%'}}/>
      </div>
    </div>
    <div class="col-md-4">
      <div class="thumbnail" style={{border: '10px solid #CBB79A'}}>

      <img src='./img/img/110250812_3188572621225529_3962334484656372129_n.jpg' style={{width: '100%'}}/>
      </div>
    </div>
    <div class="col-md-4">
      <div class="thumbnail" style={{border: '10px solid #CBB79A'}}>

      <img src='./img/img/107896606_3175015815914543_2137527558136187998_n.jpg' style={{width: '100%'}}/>
      </div>
    </div>

           </div>
        </div>
          </div>


       </section>
     


       {/* contact section start */}

        <section id="contact-section">
        <div className="contact-details">
          <div className="contact-title">
         
          <center> <h5 style={{fontSize: '35px'}}><b>History</b><span style={{color: '#F88927', fontSize: '40px'}}>.</span></h5></center>

          </div>
          <div className="contact-info">
            <div className="company-name text-center">
             <center>
              <h6 style={{color: '#7F837F', lineHeight: '30px'}}>S.N.Hospital is founded by Dr.S.N.Pillai in the year of 1944. Dr S.N.Pillai hailing from Nedumpallil family started his career as a school teacher. He got inspired from his uncle Nedumpallil Padmanabha pillai who was a renowned ayurvedic paediatrician. Leaving his job as a school teacher he took his L.M.P (Licensed Medical Practitioner a degree given by British Govt. Before the M.B.B.S course was introduced) from Stanley medical college Chennai. Unlike his contemporaries who opt to work in cities instead of going back their homes Dr. S.N.Pillai opted to work and serve for the village given birth to him. Niranam a place in Thiruvalla taluk, Kerala. was a portion of upper kuttanad surrounded by rivers and the villagers had to cross the river in a hurry to take the patients to Hospitals in Thiruvalla . As he wanted to serve his village he started a clinic in the year 1944 in his friend Mathaikutty Mookacherils residence. Dr.S.N.Pillai believed in human values and was social reformer and he visited in houses of many patients despite their caste or religion which invited the objection of narrow-minded traditionalists in that time . Then he changed the premises to Kadapra junction in own building . The name was “ Amrithasaras” named after his daughter who expired in childhood because of in adequate treatment aid in village. Later his son Dr.S.Sulochanan Pillai joined him after completion of M.B.B.S from Cuttack medical college Orissa. the hospital was added with more facilities X-ray , ECG and Laboratory , Pharmacy and Full-fledged Labour room and rooms for admission the Hospital was named S.N.Nursing Home. Dr. S.N.Pillai and Dr.Sulochanan Pillai observed philanthropic approach in the management of Hospital they did free treatments for poor and helped many of them from their own pocket. The present management believes even though the lights scattered by the founders is gone their glow remains to inspire them to the heights sublime.</h6>
              </center>
            </div>
          </div>
        </div>
       </section>
     
     {/* contact section end */}

              <section id="blog-section">
        <div className="blog-details">
        <div className="blog-title">
        <center> <h5 style={{fontSize: '35px'}}><b>News Update</b><span style={{color: '#F88927', fontSize: '40px'}}>.</span></h5></center>
              </div>
          <div className="blog-list">
          <div className="row">

          <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            </div>

            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div className="blog-img-content">
                  <div className="blog-image">
                    <img src={blog} width="100%" height="50%"/>
                  </div>
                  <div className="blog-content">
                    <div className="blog-text">
                      <span>
                      FORMAL ANNOUNCEMENT OF NABH CERTIFICATION BY HON MLA THIRUVALLA MATHEW T THOMAS IN PRESENCE OF KADAPRA PANCHAYATH PRESIDENT NISHA ASHOKAN , WARD MEMBER MINI JOSE AND SENIOR MEDICAL OFFICERS.
                      </span>
                    </div>
                  </div>
                </div>
             
            </div>

            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div className="blog-img-content">
                  <div className="blog-image">
                    <img src={ndah} width="100%"/>
                  </div>
                  <div className="blog-content">
                    <div className="blog-text">
                      <span>
                      NABH Certificate. 
                      </span>
                    </div>
                  </div>
                </div>
             
            </div>

            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            </div>

          </div>
           
          </div>
        </div>
       </section>





       {/* footer section start */}

       <section className="footer-section">
          <footer className="footer-details">
            <div className="row">
            <div className="col-lg-5 col-xl-5">
          <div className="copyright-text">
                <div>
                <img className="my-2" src="./img/img/logo.png" width="250px"/>
                </div>
                <span style={{color: '#7F837F', fontSize: '16px'}}>Copyright © 2021-{yearFetch}</span>

              </div>
              
              <div className="social-media-icon" style={{display:'flex'}}>
              <i className="fa fa-facebook" aria-hidden="true"></i>
              <i className="fa fa-twitter" aria-hidden="true"></i>
              <i className="fa fa-linkedin" aria-hidden="true"></i>
              </div>
              </div>

              <div className="col-lg-3 col-xl-3">
              <img className="my-2" src={logo1} width="250px"/>
                </div>

              <div className="col-lg-4 col-xl-4">
              <div>
              <span style={{color: '#7F837F', fontSize: '16px'}}>S U B S C R I B E</span>
              <br/>
              <br/>
              <h6 style={{color: '#7F837F', fontSize: '16px'}}>Sign up for Alerts and Updates.</h6>
                </div>
              </div>
              </div>


          </footer>
       </section>
    

     {/* footer section end */}

    </div>
  );
}

export default App;
